document.addEventListener('DOMContentLoaded', function () {
  var elements = document.querySelectorAll('[data-flicker-text]');
  if (!elements.length) return;

  elements.forEach(function (el) {
    // HTML original del título/subtítulo
    var rawHTML = el.innerHTML.trim();
    if (!rawHTML) return;

    // Usamos un div temporal para leer bien los <br> y nodos
    var tmp = document.createElement('div');
    tmp.innerHTML = rawHTML;

    var lines = [];
    var currentLine = '';

    tmp.childNodes.forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
        // Cada <br> cierra una línea
        lines.push(currentLine);
        currentLine = '';
      } else {
        // Acumulamos HTML (span, texto, etc.)
        if (node.nodeType === Node.ELEMENT_NODE) {
          currentLine += node.outerHTML;
        } else if (node.nodeType === Node.TEXT_NODE) {
          currentLine += node.textContent;
        }
      }
    });

    if (currentLine) {
      lines.push(currentLine);
    }

    // Si no había <br> ni nada raro, al menos tenemos una línea
    if (!lines.length) {
      lines = [rawHTML];
    }

    // Limpiamos el contenido original
    el.innerHTML = '';

    // Construimos las líneas con spans + <br>
    lines.forEach(function (line, index) {
      var span = document.createElement('span');
      span.classList.add('flicker-line');
      span.classList.add('flicker-preserve');
      span.innerHTML = line;
      el.appendChild(span);

      // Mantener los saltos visuales entre líneas
      if (index < lines.length - 1) {
        el.appendChild(document.createElement('br'));
      }

      // Delay por línea (flicker escalonado)
      setTimeout(function () {
        span.classList.add('is-visible');
      }, 250 * index);
    });
  });
});
